export default function AppNotificationsService($http, appSettings) {
  'ngInject';
  var notificationUrl = appSettings.InReachApiEndpoint + '/app/notifications';

  this.getActiveAppNotifications = function () {
    var endpoint = notificationUrl + '/active';
    return $http.get(endpoint);
  };

  this.acknowledgeNotications = function (notificationsList) {
    var endpoint = notificationUrl + '/acknowledge';
    return $http.post(endpoint, notificationsList);
  };
}